export const EnvironmentTypes = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;

export type EnvironmentTypes = (typeof EnvironmentTypes)[keyof typeof EnvironmentTypes];
